import { Link } from 'react-router-dom';

const Successstory = ({prm}) => {

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth' // Optional, for smooth scrolling
    });
  }; 

  return (      
    <div>
        <Link className="casestudies" to={`/success-story/details/${prm.slug}`} onClick={scrollToTop}>
          <img src={prm.image} alt={prm.name} /> 
          <p className="blue">{prm.case_type}</p>
          <h4>{prm.short_description}</h4>
        </Link>                            
    </div> 
    );

}

export default Successstory